import {
    Box,
    Checkbox,
    FormControlLabel,
    TextField,
    Typography,
} from '@mui/material';
import { SERVICE_RATES, ServiceKey } from '../utils/constants';

export interface ServiceSelection {
    key: ServiceKey;
    enabled: boolean;
    rate: number;
}

interface ServiceSelectorProps {
    services: ServiceSelection[];
    onChange: (services: ServiceSelection[]) => void;
}

export const ServiceSelector = ({ services, onChange }: ServiceSelectorProps) => {
    const handleToggle = (key: ServiceKey) => {
        onChange(
            services.map((s) =>
                s.key === key ? { ...s, enabled: !s.enabled } : s
            )
        );
    };

    const handleRateChange = (key: ServiceKey, value: string) => {
        const rate = parseFloat(value) || 0;
        onChange(
            services.map((s) => (s.key === key ? { ...s, rate } : s))
        );
    };

    return (
        <Box>
            <Typography variant="subtitle2" gutterBottom>
                Services
            </Typography>
            {services.map((service) => (
                <Box
                    key={service.key}
                    display="flex"
                    alignItems="center"
                    gap={2}
                    mb={1}
                >
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={service.enabled}
                                onChange={() => handleToggle(service.key)}
                                size="small"
                            />
                        }
                        label={SERVICE_RATES[service.key].label}
                        sx={{ minWidth: 160 }}
                    />
                    <TextField
                        type="number"
                        size="small"
                        value={service.rate}
                        onChange={(e) => handleRateChange(service.key, e.target.value)}
                        disabled={!service.enabled}
                        InputProps={{ startAdornment: '$' }}
                        sx={{ width: 120 }}
                    />
                </Box>
            ))}
        </Box>
    );
};
